import type { AnalyticsEvent } from './transport';
import type { VendorConfig } from './vendors';
type View=Window & typeof globalThis;
export const METRICA_GOALS={pricing:'bb_pricing_view',plan:'bb_plan_select',registration:'bb_registration_start',trailer:'bb_trailer_end',download:'bb_download_available'} as const;

export function createVendorGoals(view:View,config:VendorConfig){
  const sent=new Set<string>();let active=true;
  const reach=(goal:string)=>{
    if(!active||sent.has(goal))return;
    const target=view as unknown as {ym?:(...args:unknown[])=>void;gtag?:(...args:unknown[])=>void};
    if(!target.ym&&!target.gtag)return;
    sent.add(goal);
    if(config.metrica)target.ym?.(config.metrica,'reachGoal',goal);
    if(config.ga4)target.gtag?.('event',goal);
  };
  const registration=()=>reach(METRICA_GOALS.registration);
  view.addEventListener('bb:registration-start',registration);
  return {
    push(event:AnalyticsEvent){
      const p=event.props;
      if(event.name==='plan_interest'&&p.action==='view')reach(METRICA_GOALS.pricing);
      if(event.name==='plan_interest'&&p.action==='select')reach(METRICA_GOALS.plan);
      if(event.name==='route_depth'&&p.reached_pricing===true)reach(METRICA_GOALS.pricing);
      if(event.name==='route_depth'&&Number(p.film_q)===4)reach(METRICA_GOALS.trailer);
      if(event.name==='download_click'&&p.available===true)reach(METRICA_GOALS.download);
    },
    stop(){active=false;view.removeEventListener('bb:registration-start',registration);},
  };
}
